import React, { useEffect, useState } from "react"; 
import Advisors from "../../../../components/Advisors/Advisors";
import LearningSpecialist from "../../../../components/LearningSpecialist/LearningSpecialist";
import "./RecentEnrollment.css";
import DashboardList from "../DashboardList/DashboardList";
import { useNavigate } from "react-router";
import { arrow_outward } from "../../../../assets/images/images";

const TABS = ["Teachers", "Students", "Advisor", "Learning Specialist"];

function RecentEnrollment() {
  const [activeTab, setActiveTab] = useState("Teachers");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
  const tabRefs = React.useRef({});

 useEffect(() => {
  const el = tabRefs.current[activeTab];
  if (el) {
    setIndicatorStyle({
      left: el.offsetLeft,
      width: el.offsetWidth,
    });
  }
}, [activeTab]);

  const VIEW_ALL_ROUTES = {
      Teachers: "/dashboard/teachers",
      Students: "/dashboard/students",
      Advisor: "/dashboard/advisors",
      "Learning Specialist": "/dashboard/learning-specialist",
    };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Teachers":
      case "Students":
      return (
        <DashboardList
          defaultTab={activeTab === "Teachers" ? "Teacher" : "Student"}
        />
      );

      case "Advisor":
        return <Advisors isPreview />;

      case "Learning Specialist":
        return <LearningSpecialist isPreview />;

      default:
        return null;
    }
  };

  return (
    <div className="re-wrapper">
      <h3 className="re-title">Recent Enrollment</h3>

      {/* Mobile Dropdown */}
<div className="md:hidden w-full mb-3 relative">
<div className="relative">
  <div className="flex items-center justify-between py-2 text-sm font-medium cursor-pointer relative">
    
    <div onClick={() => setOpen(!open)} className="flex items-center gap-2 relative">
      <span
        ref={(el) => (tabRefs.current[activeTab] = el)}
        className="text-gray-800"
      >
        {activeTab}
      </span>

      <svg
        className={`w-4 h-4 text-gray-600 transition-transform duration-300 ${
          open ? "rotate-180" : ""
        }`}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  </div>

  <div className="absolute -translate-x-1/2 w-[100%] h-[1px] bg-gray-300"></div>

  <span
    className="absolute bottom-[-2px] h-[4px] bg-blue-600 transition-all duration-300"
    style={{
      left: indicatorStyle.left,
      width: indicatorStyle.width,
    }}
  />
</div>

  {/* DROPDOWN */}
  {open && (
    <div className="absolute left-0 top-full w-full bg-white z-50 shadow-md">
      {TABS.map((tab) => (
        <div
          key={tab}
          onClick={() => {
            handleTabClick(tab);
            setOpen(false);
          }}
          className={`w-full px-2 py-2 text-sm cursor-pointer ${
            activeTab === tab
              ? "text-blue-600 font-semibold"
              : "text-gray-700"
          } border-b border-gray-200`}
        >
          {tab}
        </div>
      ))}
    </div>
  )}
</div>

{/* Desktop Tabs */}
<div className="re-tabs hidden md:!flex gap-4 mb-3">
  {TABS.map((tab) => (
    <button
      key={tab}
      className={`re-tab ${activeTab === tab ? "active" : ""}`}
      onClick={() => handleTabClick(tab)}
    >
      {tab}
    </button>
  ))}
</div>

      {/* Tab Content */}
      <div className="re-content">
        {renderContent()}
      </div>

      <div style={{ textAlign: "center", marginTop: 12 }}>
        <span
          style={{ color: "#0068FF", fontSize: 13.5, fontWeight: 500, cursor: "pointer" }}
          onClick={() => navigate(VIEW_ALL_ROUTES[activeTab])}
        >
          View All <img src={arrow_outward} alt="arrow"/>
        </span>
      </div>
    </div>
  );
}

export default RecentEnrollment;